import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';
import { setCategoryBenefits } from '../../redux/actions';
import store from "../../redux";
import {getABParticipationStatus} from "../../app/functions";

class GetCategoryBenefits extends baseRequest
{
    constructor() {
        super();
        this.name = 'GetCategoryBenefits';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.payload = payload;
        const { searchConfiguration } = store.getState().config.Parameters;
        const {abTestingPercentageForCategory,apiPath} = searchConfiguration;
        if (getABParticipationStatus('categoryABTestingIncluded', abTestingPercentageForCategory)) {
            this.useNewResponseFormat = true;
            this.call('getCategoryBenefits', this.payload, 'get', {
                basePath: apiPath,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                stringifyData: true,
            });
        }
        else {
            this.call(this.config.api.requests.getCategoryBenefits, payload);
        }
    }

    onSuccess() {
        this.updateState();
    }

    updateState() {
        this.dispatch(setCategoryBenefits(this.response.data));
    }
}

export default GetCategoryBenefits;
